let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("kutqV")).then(() => parcelRequire('3QB9u'));